var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07847 14.2447C8.7894 14.5153 8.40293 14.6667 8.00073 14.6667C7.59853 14.6667 7.21213 14.5153 6.923 14.2447C4.27535 11.7507 0.727174 8.96459 2.45751 4.91977C3.39309 2.73277 5.63889 1.33333 8.00073 1.33333C10.3626 1.33333 12.6084 2.73277 13.544 4.91977C15.2721 8.95953 11.7327 11.7593 9.07847 14.2447Z",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 7.33333C10.3332 8.622 9.2885 9.66667 7.99984 9.66667C6.71117 9.66667 5.6665 8.622 5.6665 7.33333C5.6665 6.04467 6.71117 5 7.99984 5C9.2885 5 10.3332 6.04467 10.3332 7.33333Z",
    stroke: "#3469E7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLocation);
export default __webpack_public_path__ + "static/media/active-location.ed6a34492844a34537734b5f6de38a2a.svg";
export { ForwardRef as ReactComponent };